"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenQrCodeDialog = exports.Name = void 0;
const Name = exports.Name = 'open-qr-code-dialog';
const OpenQrCodeDialog = exports.OpenQrCodeDialog = Name;
